module.exports = __webpack_public_path__ + "img/20210629_143139.d62ba34d.jpg";